import { Markdown } from './markdown.js';
import d from './DOM.js';

export default class Privacy {
	static init() {
		const markdownScript = d.get<HTMLScriptElement>('privacy-markdown');
		const container = d.get<HTMLElement>('privacy-content');
		
		if (markdownScript && container) {
			const markdownText = markdownScript.textContent || '';
			const html = Markdown.parse(markdownText);
			container.innerHTML = html;
		}
	}
}
